import { REFERRAL_COOKIE_DAYS } from '@maintenance-tracker/shared';

const REF_COOKIE = 'ttp_ref';
const SRC_COOKIE = 'ttp_src';

function setCookie(name: string, value: string, days: number) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]!) : null;
}

/** Capture ?ref= and ?src=qr (and similar) into 30-day cookies. */
export function captureReferralParams(search: string = window.location.search): void {
  const params = new URLSearchParams(search);
  const ref = params.get('ref');
  const src = params.get('src');
  if (ref?.trim()) setCookie(REF_COOKIE, ref.trim(), REFERRAL_COOKIE_DAYS);
  if (src?.trim()) setCookie(SRC_COOKIE, src.trim(), REFERRAL_COOKIE_DAYS);
}

export function getReferralPayload(): { referral_code?: string; referral_src?: string } {
  const referral_code = getCookie(REF_COOKIE) ?? undefined;
  const referral_src = getCookie(SRC_COOKIE) ?? undefined;
  return {
    ...(referral_code ? { referral_code } : {}),
    ...(referral_src ? { referral_src } : {}),
  };
}

export function getCarriedWebsiteUrl(): string {
  const params = new URLSearchParams(window.location.search);
  return params.get('url')?.trim() || params.get('website')?.trim() || '';
}
